export const defaultPageSize = 25;
export const defaultPageSizeOptions: [number, ...Array<number>] = [10, 25, 50, 100, 250, 500];
